<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "Reports",
};
</script>

<style lang="scss">
/*  containers/Reports */
@import "../assets/css/variables.scss";
.exportPPT {
  font-weight: bold;
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
  transition: scale 0.5s;
      &:hover{
        scale: 1.1;
      }
  .icon {
    background-color: $accent-color;
    height: 2rem;
    width: 2rem;
  }
}
.exportPDF {
  font-weight: bold;
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  text-align: center;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  cursor: pointer;
  scale: 1;
  transition: scale 0.5s;
      &:hover{
        scale: 1.1;
      }
      &:active {
        scale: 0.95;
      }
  .icon {
    background-color: $accent-color;
    height: 2rem;
    width: 2rem;
  }
}
.snapshot-selectors {
  width: calc(100% - 64px);
}
@media (max-width: 540px) {
  .export {
    position: initial;
    margin: 5px 5%;
  }
};
</style>
